(function () {
  "use strict";

  window.__tfProductAddonsLoaded = true;

  var STORAGE_KEY = "tf_address";
  var OLD_KEY = "selectedAddress";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function getAddressInput() {
    return document.getElementById("product-address-input");
  }

  function setAddress(addr) {
    if (!addr || !addr.trim()) return;
    localStorage.setItem(STORAGE_KEY, addr.trim());
    localStorage.setItem(OLD_KEY, addr.trim());
  }

  function getDealingNumbers() {
    return Array.prototype.slice.call(document.querySelectorAll(".tf-dealing-input"))
      .map(function (input) {
        return input.value.trim();
      })
      .filter(Boolean);
  }

  function getInstrumentQty(dealingNums) {
    var qtyInput = document.getElementById("product-instruments-quantity");
    if (dealingNums.length) return dealingNums.length;
    if (!qtyInput) return 1;
    return parseInt(qtyInput.value, 10) || 1;
  }

  function getSelectedAddOns() {
    return Array.prototype.slice.call(document.querySelectorAll(".tf-addon-checkbox:checked"))
      .map(function (input) {
        return {
          id: parseInt(input.getAttribute("data-variant-id"), 10),
          title: input.getAttribute("data-title") || "Add-on document"
        };
      })
      .filter(function (addon) {
        return addon.id;
      });
  }

  function showHelp(message) {
    var helpEl = document.getElementById("buy-now-help");
    if (helpEl) {
      helpEl.textContent = message;
      helpEl.style.display = "block";
    } else {
      alert(message);
    }
  }

  function hideHelp() {
    var helpEl = document.getElementById("buy-now-help");
    if (helpEl) helpEl.style.display = "none";
  }

  function buildItems(address) {
    var root = document.getElementById("tf-addons");
    var mainVariantId = root ? parseInt(root.getAttribute("data-main-variant-id"), 10) : 0;
    var productTitle = root ? root.getAttribute("data-product-title") || "" : "";
    var dealingSection = document.getElementById("dealing-numbers-section");
    var dealingNums = dealingSection ? getDealingNumbers() : [];

    if (!mainVariantId) {
      throw new Error("The product could not be added. Please refresh the page and try again.");
    }

    if (dealingSection && dealingNums.length === 0) {
      var firstInput = document.querySelector(".tf-dealing-input");
      if (firstInput) firstInput.focus();
      throw new Error("Please enter at least one dealing number, or order a Current Title first to find the dealing numbers.");
    }

    var quantity = getInstrumentQty(dealingNums);
    var properties = { "Property Address": address };
    if (dealingNums.length > 0) {
      properties["Dealing Numbers"] = dealingNums.join(", ");
      properties["Instruments Quantity"] = String(dealingNums.length);
    } else if (document.getElementById("product-instruments-quantity")) {
      properties["Instruments Quantity"] = String(quantity);
    }

    var items = [{
      id: mainVariantId,
      quantity: quantity,
      properties: properties
    }];

    getSelectedAddOns().forEach(function (addon) {
      items.push({
        id: addon.id,
        quantity: 1,
        properties: {
          "Property Address": address,
          "Add-on for": productTitle
        }
      });
    });

    return items;
  }

  function wireBuyButton() {
    window.__tfProductAddonsWireAttempts = (window.__tfProductAddonsWireAttempts || 0) + 1;

    var btn = document.getElementById("buy-now-button");
    if (!btn || btn.__tfAddonWired) return;

    btn.setAttribute("type", "button");
    btn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var input = getAddressInput();
      var address = input ? input.value.trim() : "";

      if (!address) {
        showHelp("Please enter a valid Australian property address or title reference.");
        if (input) input.focus();
        return;
      }

      hideHelp();
      setAddress(address);

      var originalText = btn.textContent;
      btn.disabled = true;

      try {
        var items = buildItems(address);
        btn.textContent = items.length > 1 ? "Adding " + items.length + " items..." : "Adding...";

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok || (result.data && result.data.status === 422)) {
              throw new Error((result.data && (result.data.description || result.data.message)) || "Error adding to cart");
            }
            return fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ attributes: { "Property Address": address } })
            });
          })
          .then(function () {
            window.location.href = "/cart";
          })
          .catch(function (error) {
            console.error("Error adding to cart:", error);
            btn.disabled = false;
            btn.textContent = originalText || "Buy Now";
            showHelp(error && error.message ? error.message : "Something went wrong. Please try again.");
          });
      } catch (error) {
        btn.disabled = false;
        btn.textContent = originalText || "Buy Now";
        showHelp(error && error.message ? error.message : "Something went wrong. Please try again.");
      }
    }, true);

    btn.__tfAddonWired = true;
  }

  window.tfProductAddonsWire = wireBuyButton;

  ready(wireBuyButton);
  window.addEventListener("load", wireBuyButton);
})();

(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function injectLocalPageEnhancements() {
    var local = document.querySelector(".tf-local");
    if (!local || local.__tfLocalEnhanced) return;
    local.__tfLocalEnhanced = true;

    if (!document.getElementById("tf-local-enhancement-style")) {
      var style = document.createElement("style");
      style.id = "tf-local-enhancement-style";
      style.textContent = [
        ".tf-local .tf-local__primary,.tf-local .tf-local__card a,.tf-local .tf-local__search button{color:#fff!important;-webkit-text-fill-color:#fff!important}",
        ".tf-local .tf-local__hero{position:relative;overflow:hidden;min-height:560px;padding:72px 20px 58px;text-align:center;background:#f7fbfe;border-bottom:1px solid #d9e1dd}",
        ".tf-local .tf-local__search{width:100%;max-width:760px;margin:0 auto 18px;padding:14px 16px 16px;border:1px solid #cfe0e8;border-radius:8px;background:#fff;box-shadow:0 18px 45px rgba(15,47,58,.08);text-align:left}",
        ".tf-local .tf-local__search label{position:static;width:auto;height:auto;overflow:visible;clip:auto;display:block;margin:0 0 10px;color:#0f172a;font-size:14px;font-weight:800}",
        ".tf-local .tf-local__search-row{display:flex;align-items:stretch;gap:8px;padding:5px;border:2px solid #d1e3e8;border-radius:14px;background:#fff;box-shadow:0 4px 20px rgba(0,0,0,.06);transition:border-color .3s,box-shadow .3s}",
        ".tf-local .tf-local__search-row:focus-within{border-color:#145369;box-shadow:0 4px 24px rgba(20,83,105,.14)}",
        ".tf-local .tf-local__search-input{flex:1;min-width:0;min-height:52px;padding:14px 18px;border:0;border-radius:10px;color:#0f172a;background:transparent;font:inherit;font-size:15px;outline:none}",
        ".tf-local .tf-local__search-input:focus{box-shadow:none}",
        ".tf-local .tf-local__search button{min-height:52px;padding:0 28px;border:0;border-radius:10px;background:linear-gradient(135deg,#145369 0%,#0f2f3a 100%);font:inherit;font-size:14px;font-weight:800;cursor:pointer;transition:transform .15s,box-shadow .2s}",
        ".tf-local .tf-local__search button:hover{transform:translateY(-2px);box-shadow:0 6px 20px rgba(15,47,58,.18)}",
        ".tf-local .tf-local__search .tf-local__clear{display:none;width:30px;flex:0 0 30px;min-height:30px;align-self:center;padding:0;border:0;border-radius:50%;background:#eef6f9;color:#145369!important;font-size:20px;font-weight:700;line-height:1;cursor:pointer}",
        ".tf-local .tf-local__search .tf-local__clear.is-visible{display:inline-flex;align-items:center;justify-content:center}",
        ".tf-local .tf-local__search .tf-local__clear:hover,.tf-local .tf-local__search .tf-local__clear:focus{background:#dff5f6;color:#0f2f3a!important;box-shadow:none}",
        ".tf-local .tf-local__search-help{margin:10px 0 0;text-align:center;color:#64748b;font-size:12px;font-weight:600;line-height:1.45}",
        "@media(max-width:820px){.tf-local .tf-local__search-row{flex-direction:column}.tf-local .tf-local__search-input{padding-right:18px}.tf-local .tf-local__search .tf-local__clear{position:static;width:100%;min-height:36px;margin:2px 0 6px;border-radius:8px;transform:none;font-size:0}.tf-local .tf-local__search .tf-local__clear:before{content:'Clear';font-size:14px}.tf-local .tf-local__search .tf-local__clear:hover,.tf-local .tf-local__search .tf-local__clear:focus{transform:none}.tf-local .tf-local__search button{width:100%}}"
      ].join("");
      document.head.appendChild(style);
    }

    local.querySelectorAll(".tf-local__primary,.tf-local__card a").forEach(function (link) {
      link.style.color = "#fff";
      link.style.webkitTextFillColor = "#fff";
    });

    if (local.querySelector(".tf-local__search")) return;

    var hero = local.querySelector(".tf-local__hero");
    var actions = local.querySelector(".tf-local__actions");
    var primary = local.querySelector(".tf-local__primary") || local.querySelector(".tf-local__card a");
    if (!hero || !actions || !primary) return;

    var form = document.createElement("form");
    form.className = "tf-local__search";
    form.setAttribute("autocomplete", "off");
    form.setAttribute("data-target-url", primary.getAttribute("href") || "/collections/all");
    form.innerHTML =
      '<label for="tf-local-address-fallback">Start with the property details</label>' +
      '<div class="tf-local__search-row">' +
      '<input id="tf-local-address-fallback" class="tf-local__search-input" type="text" name="address" placeholder="Enter property address, lot/plan or title reference">' +
      '<button class="tf-local__clear" type="button" aria-label="Clear property details">&times;</button>' +
      '<button type="submit">Start order</button>' +
      "</div>" +
      '<p class="tf-local__search-help">We will carry this into the order form so you do not need to type it again.</p>';

    actions.parentNode.insertBefore(form, actions);

    var input = form.querySelector(".tf-local__search-input");
    var clearButton = form.querySelector(".tf-local__clear");

    function syncClearButton() {
      if (!clearButton || !input) return;
      clearButton.classList.toggle("is-visible", Boolean(input.value.trim()));
    }

    function clearLocalAddress() {
      try {
        localStorage.removeItem("tf_address");
        localStorage.removeItem("selectedAddress");
      } catch (error) {}
    }

    try {
      var params = new URLSearchParams(window.location.search);
      input.value = params.get("address") || localStorage.getItem("tf_address") || localStorage.getItem("selectedAddress") || "";
      syncClearButton();
    } catch (error) {}

    function saveLocalAddress(value) {
      if (!value) return;
      try {
        localStorage.setItem("tf_address", value);
        localStorage.setItem("selectedAddress", value);
      } catch (error) {}
    }

    function ensureLocalGooglePlaces() {
      if (window.google && window.google.maps && window.google.maps.places) return;
      if (document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) return;
      var script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyC_O-x6rJdOOTigz62uTZjWUzcCPgfQW44&libraries=places";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    function initLocalPlaces() {
      if (!input || input.__tfLocalPlaces) return;
      if (!window.google || !window.google.maps || !window.google.maps.places) return;

      var autocomplete = new google.maps.places.Autocomplete(input, {
        types: ["address"],
        componentRestrictions: { country: "AU" },
        fields: ["formatted_address", "address_components"]
      });

      autocomplete.addListener("place_changed", function () {
        var place = autocomplete.getPlace();
        var address = place && place.formatted_address ? place.formatted_address : input.value.trim();
        if (!address) return;
        input.value = address;
        input.classList.add("valid-address");
        saveLocalAddress(address);
        syncClearButton();
      });

      input.__tfLocalPlaces = autocomplete;
    }

    ensureLocalGooglePlaces();
    var localPlacesAttempts = 0;
    var localPlacesTimer = setInterval(function () {
      localPlacesAttempts += 1;
      initLocalPlaces();
      if ((input && input.__tfLocalPlaces) || localPlacesAttempts > 80) clearInterval(localPlacesTimer);
    }, 150);

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var value = input.value.trim();
      var targetUrl = form.getAttribute("data-target-url") || "/collections/all";
      if (value) {
        saveLocalAddress(value);
        targetUrl += (targetUrl.indexOf("?") >= 0 ? "&" : "?") + "address=" + encodeURIComponent(value);
      }
      window.location.href = targetUrl;
    });

    input.addEventListener("input", function () {
      input.classList.remove("valid-address");
      if (!input.value.trim()) clearLocalAddress();
      syncClearButton();
    });

    if (clearButton) {
      clearButton.addEventListener("click", function () {
        input.value = "";
        input.classList.remove("valid-address");
        clearLocalAddress();
        syncClearButton();
        input.focus();
      });
    }
  }

  ready(injectLocalPageEnhancements);
  window.addEventListener("load", injectLocalPageEnhancements);
})();
